import { getFrontendConfigValue } from '@arnold/common';

/**
 * Starts the SSO login by navigating to the API, which looks up the OIDC
 * provider configured for the user's organization and redirects to it.
 * All OIDC state (state, nonce, PKCE) is handled server-side.
 */
export function redirectToSsoLogin(email: string, redirect?: string | null): void {
  const params = new URLSearchParams({ email });
  const normalizedRedirect = redirect?.trim();
  if (normalizedRedirect) {
    params.set('redirect', normalizedRedirect);
  }
  window.location.href = `${getFrontendConfigValue('API_URL')}/auth/sso/login?${params.toString()}`;
}
